var map = {
	"./banprime/logo-text-color.png": "dced",
	"./ezzebank/logo-text-color.png": "5465",
	"./groovebank/logo-text-color.png": "e67b",
	"./hubchain/logo-text-color.png": "0da5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9d6";